import React, { useState, useContext, useEffect } from 'react';
import {
  Box,
  Button,
  TextField,
  Autocomplete,
  Tooltip,
  IconButton,
} from '@mui/material';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import { useLocation } from 'react-router-dom';
import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';
import { useLazyGetMerchantAdminRoleQuery } from '../../services/merchant';
import { setSelectedMerchant } from '../../features/merchant/merchantSlice';
import {
  setSelectedCustomerNO,
  setHashTaxIdCustomer,
  setFederalTaxId,
  setSelectCustomerEmail,
} from '../../features/merchant/custNOSlice';
import NotiAlert from '../NotiAlert/NotiAlert';
import { useNavigate } from 'react-router-dom';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';
import MenuIcon from '@mui/icons-material/Menu';
// 'Text', 'Avatar', 'Switch', 'FormControlLabel', 'Typography' ไม่ได้ถูกใช้งานในโค้ดใหม่นี้
// จึงสามารถลบออกได้หากไม่จำเป็น
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function Navbar({
  openSidebar,
  setOpenSidebar,
  handleSidebarToggle,
  handleMobileNavbarToggle,
  isMobileNavbarOpen,
}) {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const toggleLanguage = () => {
    const newLang = lang === 'th' ? 'en' : 'th';
    i18n.changeLanguage(newLang);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleAdminSignout } = useContext(PassportAuth);
  const userName = getStorage('name');
  const token = getStorage('token');
  const { COMPANY } = jwtDecode(token);
  const [custName, setcustName] = useState('');
  // 🪂 Alert ------------------------------------------------------------
  const [openAlert, setOpenAlert] = useState(false);
  const [titleAlert, settitleAlert] = useState('');
  // 🪂 Collect information ------------------------------------------
  const [vendorItem, setVendorItem] = useState([]);
  const [vendor, setVendor] = useState(null);
  const [customerCodeItems, setCustomerCodeItems] = useState([]);
  const [customerCode, setCustomerCode] = useState(null);
  // -----------------------------------------------------------------
  const location = useLocation();
  const fullPath = location.pathname + location.search;
  const supportsAllCustomers =
    location.pathname === '/' || location.pathname === '/invoice-main';
  const [getMerchantAdminRole] = useLazyGetMerchantAdminRoleQuery();
  const sorgcodeMerchant = useSelector((state) => state.merchant.value);
  const setRedux = {
    merchant: (item) => dispatch(setSelectedMerchant(item)),
    customer: (value, federal_hash_tax_id, federalTaxId, customer_email) => {
      dispatch(setSelectedCustomerNO(value));
      dispatch(setHashTaxIdCustomer(federal_hash_tax_id));
      dispatch(setFederalTaxId(federalTaxId));
      dispatch(setSelectCustomerEmail(customer_email));
    },
  };

  const setLabelMerchants = () =>
    COMPANY.map((i) => ({
      ...i,
      label: i.merchant_name,
    }));

  const setLabelCustomerCodes = (item) => {
    const options = item.map((i) => ({
      ...i,
      label: i.customer_code,
    }));

    return supportsAllCustomers && options.length > 1
      ? [{ customer_code: 'All', label: 'All' }, ...options]
      : options;
  };

  const handleOnCloseAlert = () => {
    setOpenAlert(false);
  };

  const resetTextFieldCustomer = () => {
    setCustomerCodeItems([]);
    setCustomerCode(null);
    setcustName('');
  };

  const callInfoMerchantAdminRole = async ({ tax_id, sorgcode }) => {
    try {
      const { data: merchantRow } = await getMerchantAdminRole({
        tax_id,
        sorgcode,
      });
      const { federal_tax_id, federal_hash_tax_id } = merchantRow.data[0];
      const customerOptions = setLabelCustomerCodes(
        merchantRow.data[0].customers,
      );
      const selectedCustomer = customerOptions[0];
      setRedux.customer(
        selectedCustomer.customer_code,
        federal_hash_tax_id,
        federal_tax_id,
        selectedCustomer.customer_email || '',
      );
      const allCustomerInfo = merchantRow.data[0].customers;
      const customerName = merchantRow.data[0].customer_name;
      setCustomerCodeItems(customerOptions);
      setCustomerCode(customerOptions[0]);
      setcustName(customerName);
    } catch (error) {
      resetTextFieldCustomer();
      settitleAlert(`ไม่พบเลขที่ผู้เสียภาษี ${tax_id}`);
      setOpenAlert(true);
    }
  };

  const handleKeyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (/^\d+$/.test(e.target.value)) {
        callInfoMerchantAdminRole({
          tax_id: e.target.value,
          sorgcode: sorgcodeMerchant,
        });
      }
    }
  };

  const handleOnchangeCustomerCode = (_, newValue) => {
    setCustomerCode(newValue);
    dispatch(setSelectedCustomerNO(newValue.label));
  };

  const handleOnChangeTaxId = (newValue) => {
    setcustName(newValue);
  };

  const handleMerchantChange = (_, newValue) => {
    setRedux.merchant(newValue.sorgcode);
    setVendor(newValue);
    resetTextFieldCustomer();
    setRedux.customer(null, null, null, null);
  };

  useEffect(() => {
    const setStartVendor = setLabelMerchants();
    setVendorItem(setStartVendor);
    setVendor(setStartVendor[0]);
    dispatch(setSelectedMerchant(setStartVendor[0].sorgcode));
  }, [dispatch]);

  // กำหนด sx สำหรับความกว้างแบบ responsive
  const responsiveWidth = {
    width: {
      xs: '100%', //
      lg: 250, //
    },
    minWidth: 250, //
  };

  return (
    <div>
      <NotiAlert
        open={openAlert}
        setOpen={setOpenAlert}
        title={titleAlert}
        value="error"
        onButtonClick={handleOnCloseAlert}
      />

      <nav
        className={`
          bg-[#f5f5f5]
          border-b border-[#ddd]
          shadow-none
          transition-all duration-300 ease-in-out
        `}
      >
        <div className="flex flex-col xl:flex-row gap-5 p-2 ">
          {/* ส่วน NavbarAdmin : Mobile */}
          <div className="flex xl:hidden items-center">
            <span className="text-blue-600 font-semibold">Admin</span>
            <span className="font-semibold ml-2">{userName}</span>

            <div className="ml-auto flex">
              <div className="hidden  md:flex">
                <div>
                  <Button onClick={toggleLanguage}>
                    <LanguageIcon />
                    {lang === 'th' ? 'TH' : 'EN'}
                  </Button>
                </div>
                <div>
                  <Button
                    color="error"
                    size="small"
                    onClick={() => {
                      handleAdminSignout();
                      navigate('/login-admin');
                    }}
                  >
                    <LogoutIcon />
                  </Button>
                </div>
              </div>
            </div>

            <div
              className="md:hidden flex justify-end" // เปลี่ยนจาก md:hidden
              onClick={handleSidebarToggle} // เปลี่ยนจาก handleSidebarToggle
            >
              <MenuIcon />
            </div>

            <div
              className="cursor-pointer ml-2" // เพิ่ม padding/cursor ให้กดง่ายขึ้น
              onClick={handleMobileNavbarToggle}
            >
              {isMobileNavbarOpen ? (
                <ExpandLessIcon /> /* เมื่อเมนูเปิด: แสดงลูกศรชี้ขึ้น */
              ) : (
                <ExpandMoreIcon /> /* เมื่อเมนูพับ: แสดงลูกศรชี้ลง */
              )}
            </div>
          </div>

          <div
            className={`
                  ${isMobileNavbarOpen ? 'flex flex-col' : 'hidden'}  
                  xl:flex xl:flex-row xl:flex-1 xl:items-center gap-5 /* <-- ตัวแม่ยังเหมือนเดิม */
                `}
          >
            <div className="flex flex-col xl:flex-row xl:flex-1 xl:flex-wrap items-center gap-5">
              {/* 1. Merchant Autocomplete */}
              <div className="">
                <Autocomplete
                  id="merchant_name"
                  disablePortal
                  disableClearable
                  sx={responsiveWidth} // ใช้ sx ที่กำหนด
                  size="small"
                  options={vendorItem}
                  value={vendor}
                  isOptionEqualToValue={(option, value) =>
                    option.sorgcode === value.sorgcode
                  }
                  onChange={(event, newValue) =>
                    handleMerchantChange(event, newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      sx={{
                        background: '#ffff',
                      }}
                      {...params}
                      label={t('navbar.venderCompany')}
                      variant="outlined"
                    />
                  )}
                />
              </div>

              {/* 2. Tax ID TextField (Conditional) */}
              <div>
                {fullPath === '/advance-payment' ||
                fullPath === '/waiting-for-payment' ||
                fullPath === '/invoice-main' ||
                fullPath === '/' ||
                fullPath === '/payment-history' ? (
                  <TextField
                    label={t('navbar.taxId')}
                    fullWidth
                    sx={{ ...responsiveWidth, background: '#ffff' }} // ใช้ sx ที่กำหนด
                    size="small"
                    variant="outlined"
                    value={custName}
                    onChange={(event) => {
                      handleOnChangeTaxId(event.target.value);
                    }}
                    onKeyDown={handleKeyEnter}
                  />
                ) : (
                  <div style={{ width: 250, display: 'inline-block' }} /> // ใช้ div เปล่าๆ เพื่อรักษา layout
                )}
              </div>

              <div>
                {fullPath === '/advance-payment' ||
                fullPath === '/waiting-for-payment' ||
                fullPath === '/invoice-main' ||
                fullPath === '/' ||
                fullPath === '/payment-history' ? (
                  <Autocomplete
                    id="customer_code"
                    disablePortal
                    disableClearable
                    sx={responsiveWidth} // ใช้ sx ที่กำหนด
                    size="small"
                    options={customerCodeItems}
                    value={customerCode}
                    onChange={(event, newValue) =>
                      handleOnchangeCustomerCode(event, newValue)
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.label === value.label
                    }
                    disabled={!customerCode}
                    renderInput={(params) => (
                      <TextField
                        sx={{
                          background: '#ffff',
                        }}
                        {...params}
                        label={t('navbar.custNo')}
                        variant="outlined"
                      />
                    )}
                  />
                ) : (
                  <div style={{ width: 250, display: 'inline-block' }} /> // ใช้ div เปล่าๆ เพื่อรักษา layout
                )}
              </div>
            </div>
            <div className="hidden ml-auto xl:flex items-center gap-4">
              <div className="flex flex-col items-end justify-center leading-tight">
                <span className="text-blue-600 text-[11px] font-bold uppercase tracking-wide">
                  Admin
                </span>

                <span className="text-gray-800 font-bold text-sm">
                  {userName}
                </span>
              </div>

              <div className="flex items-center gap-2">
                <Button
                  onClick={toggleLanguage}
                  size="small"
                  color="primary"
                  style={{ minWidth: 'auto', padding: '4px 8px' }}
                >
                  <LanguageIcon fontSize="small" style={{ marginRight: 4 }} />
                  <span className="font-medium text-sm pt-0.5">
                    {lang === 'th' ? 'TH' : 'EN'}
                  </span>
                </Button>

                <Button
                  color="error"
                  size="small"
                  style={{ minWidth: '40px' }}
                  onClick={() => {
                    handleAdminSignout();
                    navigate('/login-admin');
                  }}
                >
                  <LogoutIcon fontSize="small" />
                </Button>
              </div>
            </div>
          </div>
          
        </div>
      </nav>
    </div>
  );
}
